import { useRef, useEffect, useState , Fragment} from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

import Select from 'react-select';
import * as moment from 'moment';
import Clientes from './Clientes';
import Articulos from './Articulos';
import { VentasLineas } from './VentaLineas';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

//import styles 👇
import 'react-modern-drawer/dist/index.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMediaQuery } from 'react-responsive';

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 1,
    nombreCliente: "",
    direccionEnvia: "",
    rnc: "",
    tipoComprobante: "1",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0,
    totalPago: 0.00,moneda: "RD"
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    codigoAuxiliar: "",
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    precioSinITBIS: 0.00,
    ItbisIncluido: false,
    itbis: 0.00,
    descuento: 0.00,
    totalLinea: 0.00,
    fecha: new Date,
    editando: false,
    formaPago: "", 
}


const modeloDatos1F = {

    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    noFactura: "",
    clienteID: 0,
    nombreCliente: "Cliente Miscelaneo",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    telefono: "",
    fecha: new Date,
    comentario: "",
    facturado: false,
    estatus: 0,
    credito:0.00,
    efectivo: 0.00,
    tarjeta: 0.00,
    transferencia: 0.00,
    cheque: 0.00,
    totalPago: 0.00,
    devolucion: 0.00,
    creadoPor: "",
    fechaCreado: new Date,
    moneda: "RD",


}


let options = [];
let options1 = [];
let options2 = [];
let Lineas = [];
let SubTotal = 0;
let TotalDescuento = 0;
let TotalITBIS = 0;
let Total = 0;
let Pago = 0;
let migrado;
let salir = 1;


function SearchableSelect({ options }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOption, setSelectedOption] = useState('');

    // Filtrar opciones basado en el término de búsqueda
    const filteredOptions = options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
            >
                {filteredOptions.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default function Venta({ data, onData })  {
    migrado = data;

    const inputRef = useRef(null);

    const [user, setUser] = useState([window.localStorage.getItem("sesion_usuario")])
    const [interativo, Setinterativo] = useState(false);
    const [modalEditPedido, SetmodalEditPedido] = useState(false);
    const [contador, setContador] = useState(0);

    const [tabla, setTabla] = useState(modeloDatos);
    const [tabla1, setTabla1] = useState(modeloDatos1);
    const [Listado, SetListado] = useState([]);
    const [ListadoCotizacion, setListadoCotizacion] = useState([]);
    const [ListadoNumeroUnico, SetListadoNumeroUnico] = useState([]);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [ListadoArticulo, SetListadoArticulo] = useState([]);
    const [ListadoArticuloB, SetListadoArticuloB] = useState([]);
    const [SN, SetSN] = useState([]);
    const [ListadoClientes, SetListadoClientes] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModalPago, setVerModalPago] = useState(false);
    const [apagarpago, setapagarpago] = useState(false);

    const [verModal, setVerModal] = useState(false);
    const [verModalCliente, setVerModalCliente] = useState(false);
    const [verModalArticulos, setVerModalArticulos] = useState(false);
    const [verModalEditLinea, setverModalEditLinea] = useState(false);
    const [V_Procesar, setV_Procesar] = useState(false);
    const [EditLinea, setEditLinea] = useState(false);
    const [busqueda, setbusqueda] = useState("");
    const [Empresa, setEmpresa] = useState();
    const [ListadoDisponible, SetListadoDisponible] = useState([]);

    //const [tabla, setTabla] = useState(modeloDatos);
    const [tabla2, setTabla2] = useState(modeloDatos1F);

    const isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
        obtenerDatosArticulas("****");
    }, [])

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
      
        var searchData = l.filter((item) => {
            if (
                (item.nombreCliente + item.pedidoID )
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };
    let use = JSON.parse(user);


    const handleChange = (e) => {

        

        if (e.target.name == "nombreCliente" ) {
          
        }
        if (e.target.name == "rnc" && e.target.value.length > 8) {
            ValidarRNC(e.target.value);
        }
        if (e.target.name == "tipoComprobante") {

            var vsn = SN.filter(x => x.secuenciaID == e.target.value).map(x => { return x.maximo -x.siguiente   });
            
            if (vsn[0] < 0) {
                alert("Quedan:"+vsn)
            } else {
                setTabla({
                    ...tabla,
                    [e.target.name]: e.target.value
                })
            }
            

        } else { 
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })}
    }

    const handleChangeP = (e) => {
        e.target.value = parseFloat(e.target.value)
        setTabla2({
            ...tabla2,
            [e.target.name]: e.target.value, ["formaPago"]: e.target.name
        })
    }


    const ValidarRNC = async (x) => {
        let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, nombreCliente: (data1).descripcion, rnc: x
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x
                })
            }
        }
    }

   
        const handleChange2 = (e) => {
            setTabla({
                ...tabla,
                ["clienteID"]: e.value, ["nombreCliente"]: e.nombre, ["rnc"]: e.rnc, ["telefono"]: e.telefono, ["direccionEnvia"]: e.direccion
            })
    }

    const handleChange4 = (e) => {
        var itb = 0.00;
        var PrecioSinITBIS = 0.00;
        var total = 0.00;
        if (e.target.name == "descripcionArticulo") {
            setTabla1({
                ...tabla1,
                ["descripcionArticulo"]: e.target.value
            })
        }

            if (e.target.name == "precio") {
            if (Empresa.itbisIncluido) {

                PrecioSinITBIS = (e.target.value) / 1.18;
                itb = (e.target.value) - PrecioSinITBIS;
                total = PrecioSinITBIS + itb;
            } else {

                itb = ((e.target.value) * 0.18);
                total = (e.target.value) + itb;
                PrecioSinITBIS = e.precio;
            }
            setTabla1({
                ...tabla1,
                ["precio"]: e.target.value, ["itbis"]: itb,
                ["precioSinITBIS"]: PrecioSinITBIS,
                ["totalLinea"]: total
            })

        }
    }
    const handleChange3 = (e) => {
      
        

        var itb = 0.00;
        var PrecioSinITBIS = 0.00;
        var total = 0.00;
       
        if (e.itbisIncluido) {

             PrecioSinITBIS = (e.precio) / 1.18;
            itb = (e.precio) - PrecioSinITBIS;
             total = PrecioSinITBIS + itb;
        } else {
            // el itb si se sumara se cambio para que esto excluye el impuesto y salga en blanco itbs
          //  itb = ((e.precio) * 0.18);
           // total = (e.precio) + itb;
         //   PrecioSinITBIS = e.precio;
            itb = 0
         total = e.precio
          PrecioSinITBIS = e.precio;
        }
        setTabla1({...tabla1,
            pedidoLineaID:0, empresaID:1,pedidoID: tabla.pedidoID, numeroUnico: tabla.numeroUnico,
           orden:1 , articuloID: e.value, descripcionArticulo: e.nombre, almacenID: e.almacenID,
            cantidad: 1, costo: e.costo, precio: e.precio, itbis: itb,
            descuento: 0.00, precioSinITBIS: PrecioSinITBIS, itbisIncluidoP: e.itbisIncluido,
            totalLinea: total, fecha:new Date , codigoAuxiliar: e.codigoAuxiliar
        })
        tabla1.empresaID = 1.
        tabla1.numeroUnico = tabla.numeroUnico;
            tabla1.orden = "1";
                tabla1.articuloID = e.value;
                    tabla1.descripcionArticulo = e.nombre;
                        tabla1.almacenID = e.almacenID;
                            tabla1.cantidad = 1;
                                tabla1.costo = e.costo;
                                    tabla1.precio = e.precio;
                                        tabla1.itbis = itb;
                                            tabla1.descuento = 0.00;
                                                tabla1.precioSinITBIS = PrecioSinITBIS;
                                                    tabla1.itbisIncluidoP = e.itbisIncluido;
                                                        tabla1.totalLinea = total;
                                                            tabla1.fecha = (new Date);
                                                                tabla1.codigoAuxiliar = e.codigoAuxiliar;

        guardarCambios();
       // GuardarLinea(tabla.pedidoID);
    }
      
         // GuardarLinea()  
    const GuardarLinea = async (e) => {
        tabla1.pedidoID = e;
        if (tabla1.pedidoID != 0) {
        let response = await  fetch(Api + "VentasTrans/GuardarPedidoVentasLineas", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(tabla1)
        })
        if (response.ok) {
            obtenerDatosLineas(e);
            MensajeG("" + tabla1.descripcionArticulo + " Agregado")
            toast.success("Agregado")
            }
         }
    }

    const obtenerDisponible = async () => {
        let response = await fetch(Api + "VentasMantenimiento/ListaDisponible");

        if (response.ok) {
            let data = await response.json()
            SetListadoDisponible(data)

        }
    }


    const EditarLinea1 = async (x, valor, campo, sl) => {
        setV_Procesar(true)
        if (campo == 'editando') { x.editando = valor; }
        if (campo == 'descripcion') { x.descripcionArticulo = valor; }
        if (campo == 'cantidad') {
            if (valor == '') { x.cantidad = 0; } else { x.cantidad = parseFloat(valor); }
        } if (campo == 'precio') {
            if (valor == '') {valor = 0 }
            valor = parseFloat(valor);
            if (valor == '') { x.precio = 0 } else { x.precio = valor; }
        }
        if (campo == 'descuento') {
            valor = parseFloat(valor);
            if (valor == '')
            { x.descuento = 0 }
            else { x.descuento = valor; }

        }
        if (Empresa.itbisIncluido) {
            var itb = 0.00;
            var p = x.precio - x.descuento;
            p = p * parseFloat(x.cantidad)
            var PrecioSinITBIS = ((p) / 1.18) / parseFloat(x.cantidad);
            itb = (p / parseFloat(x.cantidad)) - PrecioSinITBIS;
            var total = (PrecioSinITBIS + itb) * x.cantidad;
            x.precioSinITBIS = PrecioSinITBIS;
        } else {
            var p = x.precio - x.descuento;
            p = p * parseFloat(x.cantidad)
            var itb = 0.00;
            itb = (parseFloat(p) * 0.18) / parseFloat(x.cantidad);
            x.precioSinITBIS = parseFloat(p) / parseFloat(x.cantidad);
            var total = (parseFloat(p) + (parseFloat(itb)) * parseFloat(x.cantidad));
        }
        x.itbis = itb;
        x.totalLinea = total;

        SetListadoLineas(ListadoLineas.map(p => p.pedidoLineaID === sl ? {
            ...p, x   } : p));
   
    }

    //Editar lineas
    const EditarLinea = async (x, valor, campo, sl) => {
        setV_Procesar(false)
        //if (campo == 'descripcion') { x.descripcionArticulo = valor; }
        //if (campo == 'cantidad') {
        //    if (valor == '') { x.cantidad = 1; } else { x.cantidad = valor; } }
        //if (campo == 'precio') {
        //    if (valor == '') { x.precio = 0 }else { x.precio = valor; } }
        //if (campo == 'descuento') {
        //    if (valor == '') { x.descuento = 0 } else { x.descuento = valor; }

        //}
        //if (Empresa.itbisIncluido) {
        //    var itb = 0.00;
        //    var p = x.precio - x.descuento;
        //    p = p * parseFloat( x.cantidad)
        //    var PrecioSinITBIS = ((p) / 1.18) / parseFloat(x.cantidad);
        //    itb = (p / parseFloat(x.cantidad)) - PrecioSinITBIS;
        //    var total = PrecioSinITBIS + itb;
        //    x.precioSinITBIS = PrecioSinITBIS;
        //} else {
        //    var p = x.precio - x.descuento;
        //    p = p * parseFloat(x.cantidad)
        //    var itb = 0.00;
        //    itb = (parseFloat(p) * 0.18) / parseFloat(x.cantidad);
        //    x.precioSinITBIS = parseFloat(p) / parseFloat(x.cantidad);
        //    var total = parseFloat(p) + (parseFloat(itb) * parseFloat(x.cantidad));
        //}
        //x.itbis = itb;
        //x.totalLinea = total;
        x.editando = valor;
        SetListadoLineas(ListadoLineas.map(p => p.pedidoLineaID === sl ? {
            ...p, x
        } : p));

        let response = await fetch(Api + "VentasTrans/EditarPedidoVentasLineas", {
            method: 'put',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(x)
        })
        if (response.ok) {
            setEditLinea(false)
            obtenerDatosLineas(tabla.pedidoID);

          

            toast.success("Agregado")
        }
    }
    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "VentasTrans/listaPedidoVentas");
        if (response.ok) {
            let data = await response.json();
   //         let data = data1.filter(x => x.estatus < 1).map(x => x);
            SetListado1(data)
            if (e == 1) {
                setPendiente(true)
                SetListado(data)
            }

            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
        }
    }

    const obtenerDatosCotizacion = async (e) => {
        let response = await fetch(Api + "VentasTrans/listaPedidoVentasCotizacion");
        if (response.ok) {
            let data = await response.json();
            //         let data = data1.filter(x => x.estatus < 1).map(x => x);
            setListadoCotizacion(data)
            if (e == 1) {
              //  setPendiente(true)
             //   SetListado(data)
            }

            if (pendiente) {
             //   SetListado(data)
             //   setPendiente(false)
            }
        }
    }
    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            SetSN(data.filter(x => x.esncf == 1).map(z => z))
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/"+use.empresaID);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == use.empresaID).map(e =>e)[0]
            setEmpresa(d)
        }
    }

    /// mandar venta a caja para pago
    const EnviarCaja = async (p) => {
        Swal.fire({
            title: 'Enviar a Caja',
            text: "Estas seguro de que desea enviar a caja. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
                let response =  fetch(Api + "VentasTrans/EnviarCaja/" + p);
                if (response.ok) {
                    let data =  response.json()
                    obtenerDatos(1);
                }

                setVerModal(false);
                setPendiente(false);
               

            }
        })
     
    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineas/"+pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)
            SubTotal = data.reduce((x, y) => {
                if (Empresa.itbisIncluido == 0 && tabla.tipoComprobante == 1) {
                return x + (y.precioSinITBIS * y.cantidad) + y.itbis
            } else { return x + ( y.precioSinITBIS * y.cantidad) }
            }, 0);
            TotalDescuento = data.reduce((x, y) => {
                return x + (y.descuento * y.cantidad);
            }, 0);
            TotalITBIS = data.reduce((x, y) => {
                if (Empresa.itbisIncluido == 0 && tabla.tipoComprobante == 1) { return x } else {
                    return x + (y.itbis * y.cantidad);
                }
            }, 0);
            Total = SubTotal  + TotalITBIS;
        }
    }

    const NumeroUnico = async () => {
        let response = await fetch(Api + "VentasMantenimiento/NumeroUnico");
        if (response.ok) {
            let data = await response.json()
            
            SetListadoNumeroUnico(data.filter(x => x.Pantalla =="Facturacion" && x.ID==1).map(x => x))
        }
    }


    const obtenerDatosArticulas = async (e) => {
        options1 = [];
        let response = await fetch(Api + "VentasMantenimiento/listaArticulosV/"+e);
        // options1=[];
        if (response.ok) {
            let data = await response.json()
      //      SetListado1(data)


        //    SetListadoArticulos(data)
            options1 = [];
            data.filter(x => x.activo == true && x.empresaID == use.empresaID).map(x => {
                options1.push({
                    value: x.articuloID, label: x.codigoAuxiliar + "-" + x.descripcion + "      -||              $"+x.precioPromedio, nombre: x.descripcion,
                    almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                    , cambiarPrecio: x.cambiarPrecio, itbisIncluido: x.itbisIncluido, codigoAuxiliar: x.codigoAuxiliar, tipoArticulo: x.tipoArticulo
                })
            })
            if (pendiente) {
                SetListadoArticuloB(options1)
                setPendiente(false)
            }
            SetListadoArticulo(options1);
        }
    }

    const obtenerDatosClientes = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");
        options = [];
        if (response.ok) {
            let data = await response.json()
            SetListadoClientes(data)
            data.map(x => {
                options.push({ value: x.clienteID, label: x.rnc + "-" + x.descripcion, nombre: x.descripcion, rnc:x.rnc , telefono: x.telefono, direccion:x.direccion})
            })
            tabla.clienteID = 1;
        }
    }


    useEffect(() => {
        obtenerDatos();
        NumeroUnico();
        obtenerDatosSN();
        obtenerDatosEmpresa()
        obtenerDatosClientes()
        obtenerDatosArticulas();
        obtenerDatosCotizacion();
    }, [])
    useEffect(() => {
        obtenerDisponible()
        const intervalo = setInterval(() => {
            setContador((prev) => prev + 1);
        }, 60000); // cada 2 segundos

        // Limpieza del intervalo cuando el componente se desmonta
        return () => clearInterval(intervalo); 
    }, [contador]);


    //Guardar factura
    const guardarCambios = async () => {
        SetmodalEditPedido(false)
        setInputValue("")
        if (tabla.pedidoID == 0 || modalEditPedido == true) {
            let response;
            tabla.empresaID = use.empresaID;
            if (tabla.pedidoID == 0) {

                response = await fetch(Api + "VentasTrans/GuardarPedidoVentas", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })

            } else {
                response = await fetch(Api + "VentasTrans/EditarPedidoVentas", {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })
            }

            if (response.ok) {
                let data = await response.json()
                setTabla(data);
                setPendiente(true)
                obtenerDatos();

                obtenerDatosLineas(data.pedidoID);

                obtenerDatos()
                GuardarLinea(data.pedidoID)
                inputRef.current.focus();
                SetmodalEditPedido(false)
           
            } else {
                alert("error al guardar")
            }
        } else {
            GuardarLinea(tabla.pedidoID)
            tabla1.articuloID = ""
        }
    }
    //Quitar lienas
    const quitarArticulo = async (id) => {
        let response = await fetch(Api + "VentasTrans/QuitarArticulo/" + id, { method: "DELETE" })
        if (response.ok) {
            toast.success("Proceso realizado")
            setPendiente(true)
            obtenerDatosLineas(tabla.pedidoID);
        }
    }


    //sumar secuencia numerica
    const Nuevo = async () => {
        let response = await fetch(Api + "VentasMantenimiento/SumNumeroUnico/1/Facturacion");
        if (response.ok) {
            let data = await response.json()
           tabla.numeroUnico = data;
            setVerModal(!verModal)
             setTabla(modeloDatos);
          setTabla1(modeloDatos1);
        }
        obtenerDatosArticulas();
        obtenerDatosClientes()
      
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
        setverModalEditLinea(!verModalEditLinea)
        obtenerDatosLineas(data.pedidoID);
    }
    const cerrarModal = ()  => {
        if (migrado != null ) {
            onData(false);
        }
        obtenerDatos();
        setTabla(modeloDatos);
        SetListadoLineas([]);
        setTabla1(modeloDatos1);
  setVerModal(false)
      
    }


    //Proceso de pago factura
    const ProcesarPago = async () => {
        setapagarpago(true)
        var procesar = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
        if (procesar >= -0) {
            tabla2.pedidoID = tabla.pedidoID;
            tabla2.empresaID = tabla.empresaID;
            tabla2.estatus = 1;
            tabla2.clienteID = tabla.clienteID;
            tabla2.nombreCliente = tabla.nombreCliente;
            tabla2.ncf = tabla.ncf;
            tabla2.numeroUnico = tabla.numeroUnico;
            tabla2.rnc = tabla.rnc;
            tabla2.telefono = tabla.telefono;
            tabla2.tipoComprobante = tabla.tipoComprobante
            tabla2.moneda = tabla.moneda
            tabla2.comentario = tabla.comentario;
            tabla2.SubTotal = SubTotal;
            tabla2.TotalDescuento = TotalDescuento;
            tabla2.TotalITBIS = TotalITBIS;
            tabla2.totalPago = Total;
            tabla2.credito = parseFloat(tabla2.credito);
            tabla2.efectivo = parseFloat(tabla2.efectivo);
            tabla2.tarjeta = parseFloat(tabla2.tarjeta);
            tabla2.cheque = parseFloat(tabla2.cheque);
            tabla2.transferencia = parseFloat(tabla2.transferencia);
            tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
                parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
                + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
            tabla2.creadoPor = use.correo;
            

            let response = await fetch(Api + "VentasTrans/ProcesarFactura", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla2)
            })
            if (response.ok) {

                Swal.fire(
                    'Guardado!',
                    '',
                    'success'
                )
                
                setPendiente(false)
                setTabla2(modeloDatos1F)
                setVerModalPago(false);
                setVerModal(false);
                setTabla(modeloDatos);
                SetListadoLineas([]);
                obtenerDatos(1);
                window.open("/ImpresionFactura/" + tabla.pedidoID, '_blank');
                if (migrado != null) {
                    onData(false);
                }
            }
        } else {
            Swal.fire(
                'No se puede procesar el pago!',
                'Favor revisar la distribución del pago. Restan:' +procesar,
                'warning'
            )
        }
        setapagarpago(false)
    }
      //Proceso de Cotizacion
    const ProcesarCotizacion = async () => {
        var procesar = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
        if (procesar <= 0) {
            tabla2.pedidoID = tabla.pedidoID;
            tabla2.empresaID = tabla.empresaID;
            tabla2.estatus = 1;
            tabla2.clienteID = tabla.clienteID;
            tabla2.nombreCliente = tabla.nombreCliente;
            tabla2.ncf = tabla.ncf;
            tabla2.numeroUnico = tabla.numeroUnico;
            tabla2.rnc = tabla.rnc;
            tabla2.telefono = tabla.telefono;
            tabla2.tipoComprobante = "3"
            tabla2.comentario = tabla.comentario;
            tabla2.SubTotal = SubTotal;
            tabla2.TotalDescuento = TotalDescuento;
            tabla2.TotalITBIS = TotalITBIS;
            tabla2.totalPago = Total;
            tabla2.credito = parseFloat(tabla2.credito);
            tabla2.efectivo = parseFloat(tabla2.efectivo);
            tabla2.tarjeta = parseFloat(tabla2.tarjeta);
            tabla2.cheque = parseFloat(tabla2.cheque);
            tabla2.transferencia = parseFloat(tabla2.transferencia);
            tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
                parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
                + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
            tabla2.creadoPor = user.correo;

            let response = await fetch(Api + "VentasTrans/ProcesarCotizacion", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla2)
            })
            if (response.ok) {

                setPendiente(false)
                setTabla2(modeloDatos1F)
                setVerModalPago(false);
                setVerModal(false);
                setTabla(modeloDatos);
                SetListadoLineas([]);
                obtenerDatos(1);
                window.open("/ImpresionCotizacion/" + tabla.pedidoID, '_blank');
              
                Swal.fire(
                    'Guardado!',
                    '',
                    'success'
                )
                obtenerDatosCotizacion()
            }
        } else {
            Swal.fire(
                'No se puede procesar el pago!',
                'Favor revisar la distribución del pago. Restan:' +procesar,
                'warning'
            ) }
    }

    //Anular Facturas
    const AnularFactura = (e) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Anular esta factura",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                let response = fetch(Api + "VentasTrans/AnularFactura/"+ e.pedidoID);
                if (response.ok) {
                    let data =  response.json()
                    obtenerDatos(1)
                }
           
                Swal.fire(
                    'Se realizo la anulacion!',
                    '' ,
                    'success'
                )
              
                 
            }
        })

    }
    //Anular Facturas
    const ReasignarNcf = (e) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Anular esta factura",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                let response = fetch(Api + "VentasTrans/AnularFactura/"+ e.pedidoID);
                if (response.ok) {
                    let data =  response.json()
                    obtenerDatos(1)
                }
           
                Swal.fire(
                    'Se realizo la anulacion!',
                    '' ,
                    'success'
                )
              
                 
            }
        })

    }
                 
    //EliminarITBS 
    const EliminarITBS = () => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Eliminar ITBS",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                let response = fetch(Api + "VentasTrans/EliminarITBS/" + tabla.pedidoID);
                if (response.ok) {
                    let data = response.json()
                    TotalITBIS = 0;
                }

                Swal.fire(
                    'Se realizo la eliminacion!',
                    '',
                    'success'
                )
  obtenerDatosLineas(tabla.pedidoID)

            }
        })

    }

    //Lista de facturas
    const columns = [
        {
            width: '7%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus != 0 } color="warning" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>{row.estatuss}
                    <Button hidden={row.estatus == 0} color="primary" size="sm" className="mr-2"
                        target="_blank" href={"/ImpresionFactura/" + row.pedidoID}
                    >
                        {/*ImpresionFactura*/}
                        <i className="fas fa-print"></i>
                    </Button>
                </>
            ),
        },
       
        {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
            width: '35%',
            style: {
                fontSize: "10px",
            },
           
        },  {
            name: 'Total',
            selector: row => (toMoney(row.totalPago)),//.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            sortable: true,
            width: '15%',
            style: {
                fontSize: "10px",
            },


        },  {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
            width: '15%',
        }, {
            name: 'Fecha',
            selector: row => ( moment(row.fecha).format("DD/MM/YYYY") ),
            sortable: true,
            width: '20%',
        },
        {
            width: '5%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus != 1} color="danger" size="sm" className="mr-2"
                        onClick={() => ReasignarNcf(row)}
                    >
                        <i className="fas fa-loop">R</i>
                    </Button>

                    <Button hidden={row.estatus != 1} color="danger" size="sm" className="mr-2"
                        onClick={() => AnularFactura(row)}
                    >
                        <i className="fas fa-X">X</i>
                    </Button>
                   
                </>
            ),
        },

       
    ];
    //Lista de facturas
    const columnsC = [
        {
            width: '7%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus != 0} color="warning" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>{row.estatuss}
                    <Button hidden={row.estatus == 0} color="primary" size="sm" className="mr-2"
                        target="_blank" href={"/ImpresionCotizacion/" + row.pedidoID}
                    >
                        {/*ImpresionFactura*/}
                        <i className="fas fa-print"></i>
                    </Button>
                </>
            ),
        },

        {
            name: 'No. Cot',
            selector: row => row.facturaID,
            sortable: true,
            width: '15%',
            style: {
                fontSize: "10px",
            },
        },      {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
            width: '35%',
            style: {
                fontSize: "10px",
            },
        },
        {
            name: 'Total',
            selector: row => (toMoney(row.totalPago)),//.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            sortable: true,
            width: '15%',
            style: {
                fontSize: "10px",
            },


        }, {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
            width: '15%',
        }, {
            name: 'Fecha',
            selector: row => (moment(row.fecha).format("DD/MM/YYYY")),
            sortable: true,
            width: '20%',
        },
       

    ];
    //alert(isMobile)

    //Tabla lineas
const columns1 = [
    {

            name: 'Art.ID',
        selector: row => (<>

            <Button size="sm" hidden={row.editando } color="warning"
                onClick={() => EditarLinea1(row, true, 'editando', row.pedidoLineaID)}
            > <i className="fas fa-pen-alt"></i></Button>
            <Button size="sm" hidden={!row.editando}  color="success"
                onClick={() => EditarLinea(row, false, 'descripcion', row.pedidoLineaID)}
        > <i className="fas fa-save"></i></Button>
            <i hidden={isMobile }>  {row.articuloID} </i></>),
        sortable: true,
      
        style: {
            marginLeft: '0px',
            marginRight: '-60px',

        },
    },
    {
        name: 'Codigo',
        selector: row => (row.codigoAuxiliar),
        sortable: true,
        omit: isMobile,
        style: {
            marginLeft: '1px',
            marginRight: '1px',

        },
    },
    {
        name: 'Descripcion',
        selector: row => (row.editando ? (
            < Input value={row.descripcionArticulo} onChange={(e) => EditarLinea1(row, e.target.value, 'descripcion', row.pedidoLineaID)} style={{ width: "100%" }} ></Input>) : row.descripcionArticulo),
            sortable: true,
        width: "35%",
             style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },  {
            name: 'Cantidad',
        selector: row => (row.editando ? (
            < Input type="number" value={row.cantidad} onChange={(e) => EditarLinea1(row, e.target.value, 'cantidad', row.pedidoLineaID)}  ></Input>) : row.cantidad),
            sortable: true,
        style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },{
            name: 'Precio',
        selector: row => (row.editando ? (
            < Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'precio', row.pedidoLineaID)} value={row.precio}></Input>) : row.precio),
            sortable: true,
        style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },{
            name: 'Descuento',
        selector: row => (row.editando ? (
            < Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'descuento', row.pedidoLineaID)} value={row.descuento}></Input>) : row.descuento),
            sortable: true,
        width: "10%",
        omit: isMobile,
        style: {
            marginLeft: '1px',
            marginRight: '1px',

        },
    }
    //, {
    //        name: 'Pr. Sin ITBIS',
    //    selector: row => (toMoney(row.precioSinITBIS)),//.toFixed(2)(row.itbis.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
    //        sortable: true,
    //        width: "10%",
    //}, {
    //    name: 'ITBIS',
    //    selector: row => (toMoney(row.itbis)),//(row.itbis.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
    //        sortable: true,
            
    //}
    , {
            name: 'Total',
        selector: row => ((toMoney(row.totalLinea ) )),
            sortable: true,
        width: "",
        style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },

    
        {
            name: '',
            cell: row => (
                <>
                    <Button hidden={tabla.estatus>=1} size="sm" color="danger"
                        onClick={() => quitarArticulo(row.pedidoLineaID)}
                    >X</Button>
                </>
            ),
            
            style: {
                marginLeft: '1px',
                marginRight: '1px',

            },
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingRight: '1px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                minHeight: '30px',    
            }
        },
           Cell: {
            style: {
                backgroundColor: "#eee",
                   minHeight: '30px',
                   color: '#fff',
                   padding: "2px",
             
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    
    if (migrado != null && verModal == false  )  {
        
        NumeroUnico();
        obtenerDatosSN();
        obtenerDatosArticulas()
        obtenerDatosEmpresa()
        tabla.clienteID = 1
        tabla.telefono = migrado[0].telefono;
        tabla.nombreCliente = migrado[0].nombrePaciente;
        setVerModal(true);
    }
    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    const [isOpen, setIsOpen] = useState(false)
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }

    const onChangeArt = async (e) => {
        obtenerDatosArticulas(e.target.value)
        var l = ListadoArticulo;
        setbusqueda(e.target.value);
        var searchData = l.filter((item) => {
            if (
                (item.codigoAuxiliar + item.nombre)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListadoArticuloB(searchData);
    };
   
    const MensajeG = (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });

  
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            ArtEnter(inputValue)  
           
        }
    };
    const ArtEnter = async(e)  => {
        options2 = [];
        let response1 = await fetch(Api + "VentasMantenimiento/listaArticulosVB/" + e);
        if (response1.ok) {
            let data = await response1.json()
            if (data.length > 0) {
                data.filter(x => x.activo == true).map(x => {
                    options2.push({
                        value: x.articuloID, label: x.codigoAuxiliar + "-" + x.descripcion + "      -||              $" + x.precioPromedio, nombre: x.descripcion,
                        almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                        , cambiarPrecio: x.cambiarPrecio, itbisIncluido: x.itbisIncluido, codigoAuxiliar: x.codigoAuxiliar
                    })
                })
                inputRef.current.focus();
                handleChange3(options2[0])
            } else {
                Swal.fire(
                    'Revise el codigo!',
                    'no se encontro',
                    'warning'
                )
            }
        }
            
        
    }
    const [menuPosition, setMenuPosition] = useState(false);
 
    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition({
            x: event.pageX ,
            y: event.pageY ,
        });
    };

    const handleCloseMenu = () => {
        setMenuPosition(false);
    };
    const CerrarMantenimientos = () => {
        obtenerDatosClientes()
        obtenerDatosArticulas();
        setVerModalCliente(false);
        setVerModalArticulos(false);
    };


    const Asignarvalor = (p) => {

        switch (p) {
            case "CR":
                return setTabla2({ ...tabla2, credito: Total, efectivo: 0, transferencia: 0, cheque: 0, tarjeta: 0, formaPago:"CREDITO" });
            case "TR":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: Total, cheque: 0, tarjeta: 0, formaPago: "TRANSFERENCIA" });
            case "CH":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: 0, cheque: Total, tarjeta: 0, formaPago: "CHEQUE" });
            case "TA":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: 0, cheque: 0, tarjeta: Total, formaPago: "TARJETA" });
            default:
                return setTabla2({ ...tabla2, credito: 0, efectivo: Total, transferencia: 0, cheque: 0, tarjeta: 0, formaPago: "EFECTIVO" });

        }

    }

        // Punto de Venta (POS) — Rediseño sin perder objetos, estados ni handlers
            // Reorganiza el layout para flujos de caja rápidos manteniendo los mismos nombres
            // de variables y funciones que ya usas (tabla, tabla1, tabla2, columns, columns1,
            // ListadoLineas, ListadoArticuloB, ListadoDisponible, SN, options, options1,
            // toMoney, onChangeArt, handleChange, handleChange2, handleChange3, handleChange4,
            // handleInputChange, handleKeyPress, guardarCambios, guardarCambiosObjetivos,
            // cerrarModal, ProcesarPago, ProcesarCotizacion, setVerModalPago, setVerModalCliente,
            // setVerModalArticulos, setverModalEditLinea, SetmodalEditPedido, Setinterativo,
            // setVerModalPago, setVerModalCliente, setVerModalArticulos, setverModalEditLinea,
            // SetmodalEditPedido, Setinterativo, setVerModalPago, setVerModalCliente, etc.)
            // **Solo cambia la disposición visual y estilos del POS.**
    // Punto de Venta (POS) — Rediseño sin perder objetos, estados ni handlers
    // Añadido: vista con imágenes para los artículos (tabla + cuadrícula con miniaturas)




        // ====== Estado/UI local para la vista de artículos
        const [vistaArt, setVistaArt] = useState('tabla'); // 'tabla' | 'grid'

        // ====== Utilidades para imágenes de artículos
        const artImageUrl = (id) => `/api/VentasMantenimiento/MostraFoto?art=${encodeURIComponent(id)}`;
        const imgFallback = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='; // pixel 1x1
        const getArticuloImgSrc = (x) => {
            // Prioriza campos ya existentes en tus objetos
            if (x?.imagen?.startsWith('data:image')) return x.imagen;               // ya viene en dataURL
            if (x?.imagen) return `data:image/png;base64,${x.imagen}`;               // base64 crudo
            if (x?.urlImagen) return x.urlImagen;                                    // url directa
            return artImageUrl(x.value);                                             // endpoint por id
        };

          
    return (
        <>

     
            <Fragment>
                {/* ====== ESTILOS POS MÍNIMOS (sobre Bootstrap existente) ====== */}
                <style>{`
        .pos-shell { display: grid; grid-template-columns: 1fr; gap: .75rem; }
        @media (min-width: 992px) { .pos-shell { grid-template-columns: 2fr 1fr; } }
        .pos-card { border: 1px solid #e5e7eb; border-radius: 12px; box-shadow: 0 1px 2px rgba(0,0,0,.06); background: #fff; }
        .pos-card .pos-hd { background: #4e73df; color: #fff; padding: .6rem .9rem; border-top-left-radius: 12px; border-top-right-radius: 12px; display:flex; align-items:center; justify-content:space-between; }
        .pos-card .pos-bd { padding: .8rem; }
        .pos-toolbar { display:flex; gap:.5rem; flex-wrap:wrap; align-items:center; }
        .pos-toolbar input[type="text"], .pos-toolbar input[type="search"] { max-width: 240px; }
        .pos-totals { background:#f8fafc; border:1px dashed #94a3b8; border-radius:10px; padding:.75rem; display:grid; gap:.25rem; }
        .pos-totals b { font-variant-numeric: tabular-nums; }
        .pos-actions { display:flex; flex-wrap:wrap; gap:.5rem; }
        .sticky-hd { position: sticky; top: 0; background:#fff; z-index: 1; }
        .table-sm th, .table-sm td { padding:.35rem .5rem; vertical-align: middle; }
        .offcanvas .table thead th { position: sticky; top: 0; background:#f1f5f9; }
        .kbd { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; background:#eef2ff; border:1px solid #c7d2fe; padding:.05rem .35rem; border-radius:6px; font-size:.8rem; }
        .box { display:flex; gap:.4rem; align-items:center; }
        .muted { color:#64748b; font-size:.85rem; }
        .thumb { width: 48px; height: 48px; object-fit: cover; border-radius: 8px; border: 1px solid #e5e7eb; }
        .card-grid { display:grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap:.6rem; }
        @media (min-width: 768px){ .card-grid { grid-template-columns: repeat(3, minmax(0,1fr)); } }
        @media (min-width: 1200px){ .card-grid { grid-template-columns: repeat(4, minmax(0,1fr)); } }
        .item-card { border:1px solid #e5e7eb; border-radius:10px; padding:.5rem; display:flex; gap:.5rem; align-items:center; }
        .item-card .meta { min-width:0; }
        .item-card .meta .name { font-size:.9rem; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
        .item-card .meta .muted { font-size:.78rem; }
      `}</style>

                {/* ====== BUSCADOR / SCAN / ACCIONES RÁPIDAS (Header compacto) ====== */}
                <div className="pos-card" onContextMenu={handleContextMenu}>
                    <div className="pos-hd">
                        <div className="box">
                            <strong>Venta en Proceso</strong>
                            <span className="muted">Cliente: {tabla?.nombreCliente || "—"}</span>
                        </div>
                        <div className="pos-actions">
                            <a className="btn btn-light btn-sm" onClick={() => Setinterativo(true)} title="Guía rápida">Guía</a>
                            <button className="btn btn-outline-light btn-sm" onClick={() => setverModalEditLinea(true)} title="Reimprimir / Historial">Historial</button>
                        </div>
                    </div>
                    <div className="pos-bd">
                        <div className="pos-toolbar">
                            <button
                                className="btn btn-primary btn-sm"
                                type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasTop"
                                aria-controls="offcanvasTop"
                                title="Buscar (F2)"
                            >
                                <i className="fa fa-search"></i> Buscar Artículo
                            </button>

                            {/* Entrada rápida por código / escáner */}
                            <input
                                type="text"
                                value={inputValue}
                                ref={inputRef}
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                                className="form-control form-control-sm"
                                placeholder="Escribe código y presiona Enter"
                                aria-label="Entrada rápida por código"
                            />

                            <div className="btn-group btn-group-sm" role="group" aria-label="acciones creación">
                                <button className="btn btn-secondary" onClick={() => setVerModalCliente(true)}>Nuevo Cliente</button>
                                <button className="btn btn-secondary" onClick={() => setVerModalArticulos(true)}>Nuevo Artículo</button>
                            </div>

                            <button
                                className="btn btn-outline-danger btn-sm ms-auto"
                                onClick={cerrarModal}
                                title="Reinicia todos los campos para una factura nueva"
                            >
                                Limpiar
                            </button>
                        </div>
                    </div>
                </div>

                {/* ====== LAYOUT PRINCIPAL POS ====== */}
                <div className="pos-shell">
                    {/* Columna izquierda: líneas del ticket */}
                    <div className="pos-card">
                        <div className="pos-hd">
                            <span>Ítems del Ticket</span>
                            <span className="muted">Total líneas: {ListadoLineas?.length || 0}</span>
                        </div>
                        <div className="pos-bd">
                            <DataTable
                                columns={columns1}
                                data={ListadoLineas}
                                customStyles={customStyles}
                            />
                        </div>
                    </div>

                    {/* Columna derecha: cliente, cabecera fiscal y totales */}
                    <div className="pos-card">
                        <div className="pos-hd">Datos de Facturación</div>
                        <div className="pos-bd">
                            <div className="row g-2">
                                <div className="col-md-7">
                                    <label className="form-label">* Cliente</label>
                                    <Select
                                        name={"clienteID"}
                                        onChange={handleChange2}
                                        value={options.filter(x => x.value == tabla.clienteID).map(x => x)}
                                        options={options}
                                        isDisabled={tabla.pedidoID}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <label className="form-label">Nombre Cliente</label>
                                    <Input disabled={tabla.clienteID != 1 || tabla.pedidoID} bsSize="sm" name="nombreCliente" onChange={handleChange} value={tabla.nombreCliente} />
                                </div>

                                <div className="col-6 col-md-4">
                                    <label className="form-label">RNC</label>
                                    <Input disabled={tabla.clienteID != 1 || tabla.pedidoID} bsSize="sm" maxLength="11" name="rnc" onChange={handleChange} value={tabla.rnc} />
                                </div>
                                <div className="col-6 col-md-4">
                                    <label className="form-label">Teléfono</label>
                                    <Input disabled={tabla.pedidoID} bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Dirección</label>
                                    <Input disabled={tabla.pedidoID} bsSize="sm" name="direccionEnvia" onChange={handleChange} value={tabla.direccionEnvia} />
                                </div>

                                <div className="col-6 col-md-5">
                                    <label className="form-label text-danger">Tipo NCF</label>
                                    <Input disabled={tabla.pedidoID} className="form-control" bsSize="sm" type={"select"} name="tipoComprobante" onChange={handleChange} value={tabla.tipoComprobante}>
                                        {SN.map((item) => (
                                            <option key={item.secuenciaID} value={item.secuenciaID}>{item.descripcion}</option>
                                        ))}
                                    </Input>
                                </div>
                                <div className="col-6 col-md-3">
                                    <label className="form-label text-danger">Moneda</label>
                                    <Input disabled={tabla.pedidoID} className="form-control" bsSize="sm" type={"select"} name="moneda" onChange={handleChange} value={tabla.moneda}>
                                        <option value={"RD"}>RD</option>
                                        <option value={"USD"}>USD</option>
                                        <option value={"EUR"}>EUR</option>
                                    </Input>
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Comentario</label>
                                    <Input disabled={tabla.pedidoID} bsSize="sm" rows="1" type="textarea" name="comentario" onChange={handleChange} value={tabla.comentario} />
                                </div>
                            </div>

                            {/* Resumen Totales */}
                            <hr />
                            <div className="pos-totals">
                                <div>Sub Total: <b>{toMoney(SubTotal)}</b></div>
                                <div>Total Descuento: <b>{toMoney(TotalDescuento)}</b></div>
                                <div>Total ITBIS: <b>{toMoney(TotalITBIS)}</b></div>
                                <div style={{ fontSize: '1.15rem' }}>Total a Pagar: <b>{toMoney(Total)}</b></div>
                            </div>

                            {/* Acciones de cobro */}
                            <div className="pos-actions mt-3">
                                <div hidden={V_Procesar}>
                                    <Button hidden={tabla.facturado} size="sm" color="secondary" onClick={() => ProcesarCotizacion()}>
                                        Cotizar
                                    </Button>
                                </div>

                                <div hidden={tabla.tipoComprobante == 3 || ListadoLineas.length == 0 || V_Procesar}>
                                    <Button hidden={tabla.pedidoID == 0} size="sm" color="success" onClick={() => setVerModalPago(true)}>
                                        Procesar pago
                                    </Button>
                                </div>

                                <Button size="sm" color="danger" onClick={cerrarModal} title="Reiniciar">
                                    Limpiar
                                </Button>
                            </div>

                            {/* Atajos */}
                            <div className="mt-2 muted">Atajos: <span className="kbd">F2</span> Buscar • <span className="kbd">Enter</span> Agregar por código</div>
                        </div>
                    </div>
                </div>

                {/* ====== OFFCANVAS: BÚSQUEDA DE ARTÍCULOS ====== */}
                <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasTop" aria-labelledby="offcanvasTopLabel" style={{ width: "42%" }}>
                    <div className="offcanvas-header sticky-hd">
                        <h5 id="offcanvasTopLabel" className="m-0">Búsqueda de artículo</h5>
                        <div className="box">
                            <div className="btn-group btn-group-sm" role="group" aria-label="vista">
                                <button className={`btn ${vistaArt === 'tabla' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setVistaArt('tabla')} title="Vista tabla">Tabla</button>
                                <button className={`btn ${vistaArt === 'grid' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setVistaArt('grid')} title="Vista con imágenes">Imágenes</button>
                            </div>
                            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                    </div>
                    <div className="offcanvas-body" style={{ padding: "8px" }}>
                        <Input type="search" name="busquedaart" onChange={(e) => onChangeArt(e)} placeholder="Buscar por código, nombre..." bsSize="sm" />

                        {vistaArt === 'tabla' && (
                            <div className="table-responsive mt-2">
                                <table className="table table-sm align-middle">
                                    <thead>
                                        <tr>
                                            <th>Agregar1</th>
                                            <th>Img</th>
                                            <th className="movilOcultar">Código</th>
                                            <th>Disp</th>
                                            <th>Nombre</th>
                                            <th>Precio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ListadoArticuloB.map(x => (
                                            <tr key={`${x.value}-${x.almacenID}`}>
                                                <td>
                                                    {(parseFloat(ListadoDisponible.filter(a => a.articuloID == x.value && a.almacenID == x.almacenID).map(x => x.cantidad)).toFixed(2) > 0.00 || x.tipoArticulo == 1) && (
                                                        <Button size="sm" color="primary" onClick={() => handleChange3(x)}>{"< ADD"}</Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <img
                                                        className="thumb"
                                                        src={getArticuloImgSrc(x)}
                                                        alt={x.nombre}
                                                        loading="lazy"
                                                        onError={(e) => { e.currentTarget.src = imgFallback; }}
                                                    />
                                                </td>
                                                <td className="movilOcultar">{x.codigoAuxiliar}</td>
                                                <td>{(x.tipoArticulo == 1) ? "SEV" : parseFloat(ListadoDisponible.filter(a => a.articuloID == x.value && a.almacenID == x.almacenID).map(x => x.cantidad)).toFixed(2)}</td>
                                                <td>{x.nombre}</td>
                                                <td>{toMoney(x.precio)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {vistaArt === 'grid' && (
                            <div className="card-grid mt-2">
                                {ListadoArticuloB.map(x => (
                                    <div className="item-card" key={`grid-${x.value}-${x.almacenID}`}>
                                        <img
                                            className="thumb"
                                            src={getArticuloImgSrc(x)}
                                            alt={x.nombre}
                                            loading="lazy"
                                            onError={(e) => { e.currentTarget.src = imgFallback; }}
                                        />
                                        <div className="meta">
                                            <div className="name" title={x.nombre}>{x.nombre}</div>
                                            <div className="muted">{x.codigoAuxiliar} • {(x.tipoArticulo == 1) ? 'SEV' : `${parseFloat(ListadoDisponible.filter(a => a.articuloID == x.value && a.almacenID == x.almacenID).map(x => x.cantidad)).toFixed(2)} disp.`}</div>
                                            <div><b>{toMoney(x.precio)}</b></div>
                                        </div>
                                        <div className="ms-auto">
                                            {(parseFloat(ListadoDisponible.filter(a => a.articuloID == x.value && a.almacenID == x.almacenID).map(x => x.cantidad)).toFixed(2) > 0.00 || x.tipoArticulo == 1) && (
                                                <Button size="sm" color="primary" onClick={() => handleChange3(x)}>Agregar2</Button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* ====== MENÚ CONTEXTUAL ====== */}
                {menuPosition && (
                    <ul
                        style={{ position: 'absolute', top: menuPosition.y, left: menuPosition.x, backgroundColor: 'white', border: '1px solid gray', listStyle: 'none', padding: '10px', margin: 0 }}
                        onClick={handleCloseMenu}
                    >
                        <li className="fw-bold">Opciones</li>
                        <li><a className="btn" onClick={() => SetmodalEditPedido(true)}>Editar Datos de Factura</a></li>
                        <li><a className="btn" onClick={() => EliminarITBS()}>Eliminar todos los ITBIS</a></li>
                    </ul>
                )}

                {/* ====== MODAL: PAGO ====== */}
                <Modal isOpen={verModalPago}>
                    <ModalHeader className="modal-header1">Cobrando a: {tabla.nombreCliente}</ModalHeader>
                    <ModalBody>
                        <h3> Monto a Pagar: <b>{toMoney(Total)}</b> </h3>
                        <div className="row g-2">
                            <div className="col-12 col-sm-6">
                                <FormGroup>
                                    <Label>Efectivo</Label>
                                    <div className="box">
                                        <Input bsSize="sm" type="number" name="efectivo" onChange={handleChangeP} value={tabla2.efectivo} />
                                        <Button size="sm" color="success" onClick={() => Asignarvalor("EF")}><i className="fas fa-money-bill"></i></Button>
                                    </div>
                                </FormGroup>
                            </div>
                            <div className="col-12 col-sm-6">
                                <FormGroup>
                                    <Label>Crédito</Label>
                                    <div className="box">
                                        <Input bsSize="sm" type="number" name="credito" onChange={handleChangeP} value={tabla2.credito} />
                                        <Button size="sm" color="success" onClick={() => Asignarvalor("CR")}><i className="fas fa-comment-dollar"></i></Button>
                                    </div>
                                </FormGroup>
                            </div>
                            <div className="col-12 col-sm-6">
                                <FormGroup>
                                    <Label>Tarjeta</Label>
                                    <div className="box">
                                        <Input bsSize="sm" type="number" name="tarjeta" onChange={handleChangeP} value={tabla2.tarjeta} />
                                        <Button size="sm" color="success" onClick={() => Asignarvalor("TA")}><i className="fa fa-credit-card"></i></Button>
                                    </div>
                                </FormGroup>
                            </div>
                            <div className="col-12 col-sm-6">
                                <FormGroup>
                                    <Label>Transferencia</Label>
                                    <div className="box">
                                        <Input bsSize="sm" type="number" name="transferencia" onChange={handleChangeP} value={tabla2.transferencia} />
                                        <Button size="sm" color="success" onClick={() => Asignarvalor("TR")}><i className="fas fa-exchange-alt"></i></Button>
                                    </div>
                                </FormGroup>
                            </div>
                            <div className="col-12 col-sm-6">
                                <FormGroup>
                                    <Label>Cheque</Label>
                                    <div className="box">
                                        <Input bsSize="sm" name="cheque" onChange={handleChangeP} value={tabla2.cheque} />
                                        <Button size="sm" color="success" onClick={() => Asignarvalor("CH")}><i className="fa fa-money-check"></i></Button>
                                    </div>
                                </FormGroup>
                            </div>
                        </div>
                        <h3>
                            <b> Devuelta: {toMoney((parseFloat((tabla2.efectivo)) + parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia) + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total)}</b>
                        </h3>
                    </ModalBody>
                    <ModalFooter>
                        <Button hidden={tabla.facturado} size="sm" color="success" disabled={apagarpago} onClick={() => ProcesarPago()}>
                            Pagar {tabla.facturado}
                        </Button>
                        <Button size="sm" color="danger" onClick={() => setVerModalPago(false)}>Cerrar</Button>
                    </ModalFooter>
                </Modal>

                {/* ====== MODAL: Mantenimiento Cliente ====== */}
                <Modal isOpen={verModalCliente} className="modal-preguntas">
                    <ModalHeader className="modal-header1">
                        <div className="box"><div> Mantenimiento de Clientes </div><div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerModalCliente(false)}>X</a></div></div>
                    </ModalHeader>
                    <ModalBody>
                        <Clientes />
                    </ModalBody>
                    <ModalFooter>
                        <Button size="sm" color="danger" onClick={() => CerrarMantenimientos(false)}>Cerrar</Button>
                    </ModalFooter>
                </Modal>

                {/* ====== MODAL: Mantenimiento Artículo ====== */}
                <Modal isOpen={verModalArticulos} className="modal-preguntas">
                    <ModalHeader className="modal-header1">
                        <div className="box"><div> Mantenimiento de Artículos </div><div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerModalArticulos(false)}>X</a></div></div>
                    </ModalHeader>
                    <ModalBody>
                        <Articulos />
                    </ModalBody>
                    <ModalFooter>
                        <Button size="sm" color="danger" onClick={() => CerrarMantenimientos()}>Cerrar</Button>
                    </ModalFooter>
                </Modal>

                {/* ====== MODAL: Historial / Reimpresión ====== */}
                <Modal isOpen={verModalEditLinea} className="modal-preguntas">
                    <ModalHeader className="modal-header1">
                        <div className="box"><div> Historial de facturas </div><div><a className="btn" style={{ color: "#ffff" }} onClick={() => setverModalEditLinea(false)}>X</a></div></div>
                    </ModalHeader>
                    <ModalBody>
                        <Tabs>
                            <TabList>
                                <Tab>Facturas</Tab>
                                <Tab>Cotizaciones</Tab>
                            </TabList>
                            <TabPanel>
                                <div className="row g-2">
                                    <div className="col-md-6">
                                        <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar factura" bsSize="sm" />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <DataTable columns={columns} data={Listado} pagination paginationComponentOptions={paginationComponentOptions} customStyles={customStyles} expandableRows expandableRowsComponent={VentasLineas} />
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <DataTable columns={columnsC} data={ListadoCotizacion} pagination paginationComponentOptions={paginationComponentOptions} customStyles={customStyles} expandableRows expandableRowsComponent={VentasLineas} />
                            </TabPanel>
                        </Tabs>
                    </ModalBody>
                    <ModalFooter>
                        <Button size="sm" color="danger" onClick={() => setverModalEditLinea(false)}>Cerrar</Button>
                    </ModalFooter>
                </Modal>

                {/* ====== MODAL: Editar Cabecera Pedido ====== */}
                <Modal className="modal-preguntas" isOpen={modalEditPedido}>
                    <ModalHeader className="modal-header1">
                        <div className="box"><div> EDITAR PEDIDO </div><div><a className="btn" style={{ color: "#ffff" }} onClick={() => SetmodalEditPedido(false)}>X</a></div></div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row g-2">
                            <div className="col-md-4">
                                <FormGroup>
                                    <Label>Nombre Cliente</Label>
                                    <Input bsSize="sm" name="nombreCliente" onChange={handleChange} value={tabla.nombreCliente} />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>RNC</Label>
                                    <Input bsSize="sm" maxLength="11" name="rnc" onChange={handleChange} value={tabla.rnc} />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup>
                                    <Label>Telefono</Label>
                                    <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                                </FormGroup>
                            </div>
                            <div className="col-md-4">
                                <FormGroup>
                                    <Label>* Cliente</Label>
                                    <Select name={"clienteID"} onChange={handleChange2} value={options.filter(x => x.value == tabla.clienteID).map(x => x)} options={options} />
                                </FormGroup>
                            </div>
                            <div className="col-md-4">
                                <FormGroup>
                                    <Label>Direccion</Label>
                                    <Input bsSize="sm" name="direccionEnvia" onChange={handleChange} value={tabla.direccionEnvia} />
                                </FormGroup>
                            </div>
                            <div className="col-md-3">
                                <FormGroup>
                                    <Label className="text-danger">Tipo NCF</Label>
                                    <Input className="form-control" bsSize="sm" type={"select"} name="tipoComprobante" onChange={handleChange} value={tabla.tipoComprobante}>
                                        {SN.map((item) => (<option key={item.secuenciaID} value={item.secuenciaID}>{item.descripcion}</option>))}
                                    </Input>
                                </FormGroup>
                            </div>
                            <div className="col-md-1">
                                <FormGroup>
                                    <Label className="text-danger">Moneda</Label>
                                    <Input className="form-control" bsSize="sm" type={"select"} name="moneda" onChange={handleChange} value={tabla.moneda}>
                                        <option value={"RD"}>RD</option>
                                        <option value={"USD"}>USD</option>
                                        <option value={"EUR"}>EUR</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div className="col-md-4">
                                <FormGroup>
                                    <Label>Comentario</Label>
                                    <Input bsSize="sm" rows="1" type="textarea" name="comentario" onChange={handleChange} value={tabla.comentario} />
                                </FormGroup>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button size="sm" color="success" onClick={() => guardarCambios()}>Guardar</Button>
                        <Button size="sm" color="danger" onClick={() => SetmodalEditPedido(false)}>Cerrar</Button>
                    </ModalFooter>
                </Modal>

                {/* ====== MODAL: Video Guía ====== */}
                <Modal className="modal-preguntas" isOpen={interativo}>
                    <ModalHeader className="modal-header1">Manuales interactivo</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <FormGroup>
                                <video width="100%" height="70%" controls>
                                    <source src="/imagen/Ventas.mp4" type="video/mp4" />
                                </video>
                                <Button size="sm" color="danger" onClick={() => Setinterativo(false)} className="mt-2">Cerrar</Button>
                            </FormGroup>
                        </div>
                    </ModalBody>
                </Modal>
            </Fragment>


        </>
    )

}
//export default Venta;